import clsx from 'clsx'
import { KTIcon } from '../../../helpers'
import { ProfileMenu, ThemeModeSwitcher } from '../../../partials'
import { useLayout } from '../../core'
import LedgerHeaderBalance from '../../../../app/components/LedgerHeaderBalance'
import { SecondFactorWarning } from '../../../../app/components/SecondFactorWarning'

const itemClass = 'ms-1 ms-lg-3'
const btnIconClass = 'fs-1'

const Navbar = () => {
  const { config } = useLayout()
  return (
    <div className='app-navbar flex-shrink-0'>
      <div className={clsx('app-navbar-item', itemClass)}>
        <LedgerHeaderBalance />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <SecondFactorWarning />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <ProfileMenu />
      </div>

      {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTIcon iconName='text-align-left' className={btnIconClass} />
          </div>
        </div>
      )}
    </div>
  )
}

export { Navbar }
